import apiClient from "Configuration/apiClient";
import API_CONFIG from "Configuration/apiConfig";

export const getScoreTypes = () => {
  return apiClient.get(API_CONFIG.ENDPOINTS.MASTERSHEETS.SCORETYPEDROPDOWN);
};

export const uploadStoreMaster = (file, month, year, scoretypeId) => {
  const uploadedBy = localStorage.getItem("userId") || sessionStorage.getItem("userId");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("month", month);
  formData.append("year", year);
  formData.append("scoretypeId", scoretypeId);
  formData.append("uploadedBy", uploadedBy);

  return apiClient.post(API_CONFIG.ENDPOINTS.MASTERSHEETS.UPLOAD, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    responseType: "text",
  });
};

export const getUploadLog = (month, year, scoretypeId, limit = 3) => {
  const uploadedBy = localStorage.getItem("userId") || sessionStorage.getItem("userId");

  return apiClient.get(API_CONFIG.ENDPOINTS.MASTERSHEETS.UPLOAD_LOG, {
    params: { month, year, scoretypeId, limit, uploadedBy },
  });
};